import React, { useState, useEffect } from "react";
// import IconFont from "../../_util/Iconfont";
////import "./index.less";
import SvgIcon from "../../assets/icons";

export interface IPageTitleProps {
  /** 页面标题 */
  title: string;
  /** 自定义样式 */
  customStyle?: {};
  /** 返回按钮方法 */
  onBack: () => void;
}

const PageTitle: React.FC<IPageTitleProps> = ({
  title,
  customStyle,
  onBack,
}) => {
  return (
    <div className="pageTitle" style={customStyle} onClick={onBack}>
      {/* <IconFont type="icon-arrow-left" className="iconBack" /> */}
      <SvgIcon component="ArrowLeft" className="iconBack" />
      <div className="title">{title}</div>
    </div>
  );
};

export default PageTitle;
